import axios from 'axios'
import Strings from './Strings'

axios.defaults.withCredentials = true

axios.defaults.baseURL = Strings.baseUrl

// if (process.env.NODE_ENV === 'development') {
//   axios.defaults.baseURL = 'http://localhost:8000/'
// } else if (process.env.NODE_ENV === 'production') {
//   axios.defaults.baseURL = 'https://www.bluebusinessguide.com.au/'
// } else {
//   console.log('base url not set')
// }

export default axios
